import React from 'react'
import { useTranslation } from 'react-i18next'
import CellEditor, { type CellMove } from './CellEditor'

interface Props {
  value: string
  onCommit: (v: string, move: CellMove) => void
  onCancel: () => void
  /** Defaults are the `name` rule (spec B §9.3): non-empty, at most 500 characters. */
  maxLength?: number
  allowEmpty?: boolean
  errorKey?: string
}

/** Free-text cell: `name` by default; `owner` (Freelo #32277865) passes `allowEmpty` and its own cap. */
const TextCell: React.FC<Props> = ({ value, onCommit, onCancel, maxLength = 500, allowEmpty = false, errorKey = 'Schedule_cell_invalid_name' }) => {
  const { t } = useTranslation()
  return (
    <CellEditor
      initial={value}
      validate={(v) => {
        const trimmed = v.trim()
        if (!trimmed && !allowEmpty) return t(errorKey)
        return trimmed.length <= maxLength ? null : t(errorKey)
      }}
      onCommit={onCommit}
      onCancel={onCancel}
    />
  )
}

export default TextCell
